<!--
트래킹검수 > 검수화면 > 검수대상 리스트 컴포넌트
(일괄검수 리스트)
------------------------------------
-->
<template>
    <div>


        <!-- 하우스 그룹 -->
        <house-group
            class="uk-margin-bottom"

            v-for="(houseGroup, index) in houseGroups"
            :key="houseGroup.id"
            :house-group="houseGroup"
            :csrf-token="csrfToken"
            :login-user-id="loginUserId"
            :active-house-group-id="activeHouseGroupId"

            @check:exception="msg => emitCheckException(msg)"
            @done:pack="house_id => emitPacking(house_id)"
            @done:ready="emitCheckOne"
            @done:error="emitCheckOne"
            @done:hold="emitCheckOne"

        >
        </house-group>
    </div>
</template>

<script>
    import prodListable from "../listable";

    export default {
        mixins: [
            prodListable,
        ],

        components: {
            'house-group': require('./house-group.vue').default,
        },

        data: function () {
            return {
            };
        },

        mounted: function () {
            // 처음 일괄검수가 활성화 될때, 상품조회 다시함
            this.$parent.makeHouseGroup();



            //console.log('마운트');
        },

        computed: {

        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>